import { Routes, Route, Navigate } from 'react-router-dom';
import { lazy, Suspense, useEffect } from 'react';
import { View, Spinner, IamValidationProvider } from '@smarterservices/smarter-ui';
import VirtualTestCenter from './VirtualTestCenter';
import SingleSessionViewer from './VirtualTestCenter/SingleSessionViewer';
import LoginScreen from './Login';
import TwilioSyncView from './Sync';
import Rooms from './Rooms';
import Chat from './PopupWindows/Chat';
import NotFound from './NotFound';
import { AuthProvider, ProtectedRoute } from '../context/AuthContext';
import ErrorBoundary from '../components/ErrorBoundary';
import useAppStore from '../stores/app';
import * as atatus from 'atatus-spa';
import { config } from '../config';

// Loading component
const Loading = () => (
  <View as="div" textAlign="center">
    <Spinner renderTitle="Loading" size="large" />
  </View>
);
const VtcRoutes = () => {
  const iam = useAppStore((state) => state.iam);

  if (config.vtc.atatus.install) {

    let version = null;
    let mode = 'production';

    if (typeof __APP_VERSION__ !== 'undefined') {
      version = __APP_VERSION__;
    }
    if (typeof __APP_MODE__ !== 'undefined') {
      mode = __APP_MODE__;
    }

    atatus.config(config.vtc.atatus.token, {
      console: true,
      version: version,
      tags: [mode],
    }).install();
  }

  // Initialize app store (OpenReplay tracking, desktop app detection, etc.)
  useEffect(() => {
    useAppStore.getState().initialize();
  }, []);

  return (
    <ErrorBoundary>
      <Suspense fallback={<Loading />}>
        <IamValidationProvider
          iam={iam?.iam}
          withDebug={true}
          onError={(error, context) => {
            console.log('IAM Validation Error:', error.message, context);
          }}
        >
          <AuthProvider loginScreenRoute="/vtc">
            <Routes>
              {/* Set the default page to go to the Virtual Test Center */}
              <Route path="/" element={<LoginScreen />} />
              <Route path="/vtc" element={<LoginScreen />} />

              <Route
                path="/rooms"
                element={
                  <ProtectedRoute>
                    <Rooms />
                  </ProtectedRoute>
                }
              />

              {/* Since we will be updating the path so we can trigger external scripts, just set as a wildcard */}
              <Route
                path="/rooms/:roomId/*"
                element={
                  <ProtectedRoute>
                    <VirtualTestCenter />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/installs/:installSid/exams/:examSid/session/:sessionSid"
                element={
                  <ProtectedRoute>
                    <SingleSessionViewer />
                  </ProtectedRoute>
                }
              />
              <Route path="/sync/*" element={<TwilioSyncView />} />

              <Route
                path="/windows/chat"
                element={
                  <ProtectedRoute>
                    <Chat />
                  </ProtectedRoute>
                }
              />

              {/* 404 Route */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </AuthProvider>
        </IamValidationProvider>
      </Suspense>
    </ErrorBoundary>
  );
};

export default VtcRoutes;
